import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import gTabMenu from "@/components/g-tab-menu/g-tab-menu.vue";

const name = 'PedidosCanceladosLiquidadosFluxo'

export default {
  name,

  components:{ 
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    "g-tab-menu": gTabMenu
  },

  props: { },

  mounted() { 
    this.mitt.on('apareceTab', (indexAba) => {
      this.items[indexAba].flag = true
    })

    this.mitt.on('removeTab', (listaIndex) => {
      listaIndex.forEach(e => this.items[e].flag = false)
    })

    this.getNumeroParcela()
  },

  updated() { },

  data() {
    return { 
        items: [
            {label: 'Detalhes', to: `/pedido-cancelado-liquidado-fluxo/${this.$route.params.id}/detalhes-pedido-cancelado-liquidado`, flag: true, index: 0},
            {label: 'Histórico', to: `/pedido-cancelado-liquidado-fluxo/${this.$route.params.id}/${this.$route.params.numeroParcela}/historico-pedido-cancelado-liquidado`,  flag: false, index: 1},
            {label: 'Nota Fiscal', to: `/pedido-cancelado-liquidado-fluxo/${this.$route.params.id}/nota-fiscal-pedido-cancelado-liquidado`,  flag: false, index: 2},
            {label: 'Parcelas', to: `/pedido-cancelado-liquidado-fluxo/${this.$route.params.id}/parcelas-pedido-cancelado-liquidado`,  flag: true, index: 3}
        ]
    }
  },

  methods: { 
    getNumeroParcela() {
      // this.numeroParcela = this.$store.state
    },
    tabChange(){
      if (this.itemAtivoTeste === 0)
      {
        this.mitt.emit('removeTab', [1, 2, 4, 5])
      }
    }
  },

  computed: { }
};